import { history } from './history';
import { summary } from './summary';
import { getChart } from './fuel';
// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const temperature = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      pdf: {
        title: 'Temperature - Summary',
        colsWidth: [80, 100, 50, 50, 50, 120, 100, 120, 100],
      },
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          {
            field: 'time',
            header: 'Time',
          },
          {
            field: 'averageTemp',
            header: 'Average Temp',
          },
          {
            field: 'highestTemp',
            header: 'Highest Temp',
          },
          {
            field: 'lowestTemp',
            header: 'Lowest Temp',
          },
          {
            field: 'startLocation',
            header: 'Start Location',
          },
          {
            field: 'coordinates',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            field: 'endLocation',
            header: 'End Location',
          },
          {
            field: 'coordinates2',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View Temperature Chart',
                  icon: 'icon-bar-chart',
                  iconPack: 'feather',
                  click: {
                    component: 'FuelChart',
                    data: { onReady: getTemperatureChart },
                  },
                },
                {
                  text: 'View History/Details',
                  icon: 'icon-list',
                  iconPack: 'feather',
                  click: {
                    component: 'ModalTable',
                    data: {
                      args: {
                        summary: false,
                        type: 'History',
                        table: history()[0].view.content,
                        colsWidth: [
                          80, 60, 40, 40, 40, 40, 50, 40, 120, 100, 40, 40, 40,
                        ],
                        data: 'historyData',
                      },

                      onReady: getModalTableData,
                    },
                  },
                },
                {
                  text: 'View Trips Breakdown',
                  icon: 'icon-truck',
                  iconPack: 'feather',
                  click: {
                    component: 'ModalTable',
                    data: {
                      args: {
                        summary: true,
                        type: 'Trips',
                        table: summary()[1].view.content,
                        colsWidth: [60, 80, 60, 50, 40, 60, 120, 100, 120, 100],
                        data: 'tripData',
                        noAction: true,
                      },

                      onReady: getModalTableData,
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Temperature Spike',
      icon: 'thermostat',
      pdf: {
        title: 'Temperature - Spike',
        colsWidth: [80, 100, 50, 50, 50, 120, 100, 120, 100],
      },
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          {
            field: 'time',
            header: 'Time',
          },
          {
            field: 'preferredTemp',
            header: 'Preffered Temp',
          },
          {
            field: 'highestTemp',
            header: 'Highest Temp',
          },
          {
            field: 'startLocation',
            header: 'Start Location',
          },
          {
            field: 'coordinates',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            field: 'endLocation',
            header: 'End Location',
          },
          {
            field: 'coordinates2',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View Temperature Chart',
                  icon: 'icon-bar-chart',
                  iconPack: 'feather',
                  click: {
                    component: 'FuelChart',
                    data: {
                      onReady: getTemperatureChart,
                      args: { spike: true },
                    },
                  },
                },
                {
                  text: 'View History/Details',
                  icon: 'icon-list',
                  iconPack: 'feather',
                  click: {
                    component: 'ModalTable',
                    data: {
                      args: {
                        summary: false,
                        type: 'History',
                        table: history()[0].view.content,
                        colsWidth: [
                          80, 60, 40, 40, 40, 40, 50, 40, 120, 100, 40, 40, 40,
                        ],
                        data: 'historyData',
                        spike: true,
                      },

                      onReady: getModalTableData,
                    },
                  },
                },
                {
                  text: 'View Trips Breakdown',
                  icon: 'icon-truck',
                  iconPack: 'feather',
                  click: {
                    component: 'ModalTable',
                    data: {
                      args: {
                        summary: true,
                        type: 'Trips',
                        table: summary()[1].view.content,
                        colsWidth: [60, 80, 60, 50, 40, 60, 120, 100, 120, 100],
                        data: 'tripData',
                        noAction: true,
                        // spike: true,
                      },

                      onReady: getModalTableData,
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ];
};

const getModalTableData = async (self) => {
  let param = self.data.data.args;
  let args = self.data.rowData;
  let url = param.summary
    ? 'getIndividualSummaryBreakdown'
    : 'getIndividualHistoryBreakdown';
  let options = {
    timeRange: param.spike ? parseDateRange(args.time) : self.timeRange,
    uid: self.userInfo.uid,
    unitId: args.unitId,
    assetId: args.assetId,
    assetName: args.assetName,
    configuration: self.configuration,
    type: param.type,
    geoPOIData: self.geoPOIData,
  };
  let modal = JSON.parse(JSON.stringify(self.modalTableApi));
  let field = {
    Trips: 'tripCount',
    Idling: 'idlingCount',
    Parking: 'parkCount',
  };
  return new Promise((resolve) => {
    // if (args[field[param.type]] && args[field[param.type]] == 0) {
    //   self.$vs.notify({
    //     title: 'Error',
    //     text: 'No data available',
    //     iconPack: 'feather',
    //     icon: 'icon-alert-circle',
    //     color: 'warning',
    //   });
    //   resolve(false);
    // } else {
    // self.isLoading = true;

    self.$http
      .post(`reports-utils/${url}`, options)
      .then(function (response) {
        if (response.status == 200 && response.data.success) {
          // console.log(response);
          let breakdownData = [];
          breakdownData.push({
            assetId: args.assetId,
            type: param.type,
            assetName: args.assetName,
            arr: response.data[param.data],
          });
          breakdownData[0].arr.forEach((e) => {
            modal.reportData.push(e);
          });
          // console.log(breakdownData);
          // modal.reportData = breakdownData;
          modal.table.content = JSON.parse(JSON.stringify(param.table));
          if (param.type == 'History') {
            modal.table.content.splice(4, 0, {
              field: 'temp',
              header: 'Temp',
            });
            modal.table.content.splice(5, 0, {
              field: 'humidity',
              header: 'Humidity',
            });
          } else {
            modal.table.content.splice(8, 0, {
              field: 'endLocation',
              header: 'End Location',
            });
          }
          // if (!param.noAction) {
          //   modal.table.content.pop();
          // }
          modal.table.content.forEach((e) => {
            if (
              e.header == 'Coords' ||
              e.header == 'Coord' ||
              e.header == 'Coordinates'
            ) {
              e.template.data = { component: 'GoogleMapEmbed' };
            }
          });
          modal.pdf.colsWidth = param.colsWidth;
          // self.forceRender += 1;
          // self.activeTab = self.breakdownData.length + 5;
          // self.isLoading = false;

          modal.title = `${param.type} - ${args.assetName}`;
          modal.pdf.title = modal.title;
          self.onReadyData = modal;

          resolve(true);
        } else {
          // self.isLoading = false;
          if (response.data.error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          } else {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        // self.isLoading = false;

        self.$vs.notify({
          title: 'Error',
          text: 'Try again later.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      });
    // }
  });
};
function parseDateRange(input) {
  // Split the string into start and end parts
  const [start, end] = input.split(' - ');

  // Parse the date and time components
  const parseDate = (dateTime) => {
    const [date, time] = dateTime.split(' | ');
    const [day, month, year] = date.split('/').map(Number);
    const [hours, minutes, seconds] = time.split(':').map(Number);

    // Create the date object and adjust for GMT+8 to UTC
    return new Date(
      Date.UTC(year, month - 1, day, hours - 8, minutes, seconds),
    );
  };

  // Get start and end dates as UTC
  const startDate = parseDate(start);
  const endDate = parseDate(end);

  // Adjust the end date to include the full day in UTC
  // endDate.setUTCHours(23, 59, 59, 999);

  // Return the formatted result
  return [startDate.toISOString(), endDate.toISOString()];
}
const getTemperatureChart = async (self) => {
  let param = self.data.data.args || {};
  let isSpikeChart = param.spike;
  return new Promise(async (resolve) => {
    const { data, dataSchema } = await getChart(self, {
      url: 'temperatureChart',
      isSpikeChart,
    });
    self.dataSource = tempChartOptions(self);
    self.onReadyData.title = self.dataSource.chart.exportFileName;
    // console.log(self.dataSource);
    resolve({ data, dataSchema });
  });
};

const tempChartOptions = (self) => {
  let args = self.data.rowData;
  return {
    data: null,
    navigator: {
      enabled: 0,
    },
    extensions: {
      customRangeSelector: {
        enabled: 0,
      },
    },
    chart: {
      animation: 0,
      palettecolors: '800080,000000,0000FF,008000',
      multicanvas: false,
      exportEnabled: 1,
      exportFileName: `Temperature Chart -${args.assetName}`,
    },
    caption: {
      text: `Temperature Chart -${args.assetName}`,
    },
    datamarker: null,
    yaxis: [
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_1',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_2',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_3',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_4',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Preferred_Temperature',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        plot: [
          {
            value: 'Odometer',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: '',
        },
      },
      {
        min: 0,
        max: 200,
        plot: [
          {
            value: 'Speed',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' kph',
        },
      },
    ],
  };
};

export { temperature };
